import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarImage } from '@achra/ui/avatar';
import { JOINED_USERS } from '@/modules/whitelist/mocks/users';
interface JoinedUsersBadgeProps {
  count?: number;
}
function JoinedUsersBadge(t0) {
  const $ = _c(3);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 100 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="inline-flex items-center -space-x-3.5 sm:-space-x-2.5">{JOINED_USERS.map(_temp)}</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== count) {
    t3 = <div className="mt-10 flex items-center gap-2">{t2}<p className="text-muted-foreground/80 tracking-tight">+{count} people already joined</p></div>;
    $[1] = count;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
function _temp(user) {
  return <Avatar key={user.name} className="size-8"><AvatarImage src={user.avatar} alt={user.name} /></Avatar>;
}
export { JoinedUsersBadge };